import { ProductType } from '@inter-ikea-storageone/range';
import IntegratedHandlesInfoMessage from 'components/ProductSidebar/CategoryWidget/IntegratedHandlesMessage';
import { ProductListConfig } from 'rangeConfig/@types';
import autoFillHandles from 'rangeConfig/shared/behaviors/autoFillHandles';
import removeAllHandlesFromScene from 'rangeConfig/shared/behaviors/removeAllHandlesFromScene';
import showDoors from 'rangeConfig/shared/behaviors/showDoors';
import { noProductsWithTypesInScene } from 'rangeConfig/shared/rules/noneOptionSelectedRules';

const handlesProductListConfig: ProductListConfig = {
  cardsTitle: 'name',
  cardsSubtitle: 'designText, communicatedSizeText',
  behaviors: {
    productClicked: [showDoors, autoFillHandles],
    productDropped: [showDoors, autoFillHandles]
  },
  cluster: [],
  productFilters: [],
  sortOrder: [{ path: 'name' }, { path: 'dimensions.height' }, { path: 'dimensions.width' }],
  categories: [
    {
      id: 'handles',
      products: [
        { path: 'type', value: ProductType.HANDLE },
        { path: 'type', value: ProductType.EDGE_HANDLE },
        { path: 'type', value: ProductType.KNOB }
      ],
      noneOption: {
        title: 'storageone.productListNoHandlesOptionTitle',
        subtitle: 'storageone.productListNoHandlesOptionSubtitle',
        behaviors: { removeProducts: [removeAllHandlesFromScene] },
        selected: noProductsWithTypesInScene([
          ProductType.HANDLE,
          ProductType.KNOB,
          ProductType.EDGE_HANDLE
        ])
      },
      widgets: [
        {
          component: IntegratedHandlesInfoMessage,
          alwaysShow: true
        }
      ]
    }
  ]
};

export default handlesProductListConfig;
